<template>
  <ul class="orderInfo">
    <li>
      <div class="th">开单时间</div>
      <div class="td">{{ orderDeatilsData.createTime }}</div>
    </li>
    <li>
      <div class="th">开单人员</div>
      <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
        <div slot="content">
          <p>{{ orderDeatilsData.billingStaff || '--' }}</p>
        </div>
        <div class="td" @mouseover="tooltipStatus = Lib.textShow($event)">
          {{ orderDeatilsData.billingStaff || '--' }}
        </div>
      </el-tooltip>
    </li>
    <li>
      <div class="th">订单合计</div>
      <div class="td">￥{{ orderDeatilsData.amount || '0.00' }}</div>
    </li>
    <li>
      <div class="th">订单来源</div>
      <div class="td">{{ orderDeatilsData.buySource == 0 ? '电脑端' : orderDeatilsData.buySource == 1 ? '粉丝端' : orderDeatilsData.buySource == 2 ? '店员APP' : 'Smartbox' }}</div>
    </li>
    <li v-if="isOpen.rs===0">
      <div class="th">消费人数</div>
      <div class="td">{{ orderDeatilsData.orderCustomer || '--' }}</div>
    </li>
    <li v-if="isOpen.sq===0">
      <div class="th">手牌号码</div>
      <el-tooltip v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp')" class="item" effect="light" placement="top">
        <div slot="content" style="font-size: 14px;color: #333;font-weight: 400;">{{ orderDeatilsData.handCard||'--' }}</div>
        <div class="td">{{ orderDeatilsData.handCard || '--' }}</div>
      </el-tooltip>
      <!-- <div class="td" v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp') && !orderDeatilsData.handCard" >{{ orderDeatilsData.handCard || '--' }}</div> -->
    </li>
    <li class="liTow" :class="isOpen.sq===1&&isOpen.rs===1?'liALL':isOpen.sq===1&&isOpen.rs===0?'liS':isOpen.sq===0&&isOpen.rs===1?'liS':'liTow'">
      <div class="th thTow" :class="isOpen.sq===1&&isOpen.rs===1?'th thAll':isOpen.sq===1&&isOpen.rs===0?'th thS':isOpen.sq===0&&isOpen.rs===1?'th thS':'th thTow'">备注</div>
      <div class="td">
        <span v-show="isOpen.qm===0">
          <el-popover v-if="orderDeatilsData.orderSignature" placement="right-start" trigger="hover">
            <img :src="orderDeatilsData.orderSignature" alt="">
            <span slot="reference" class="autograph autograph_G">已签名</span>
          </el-popover>
          <span v-else class="autograph autograph_D">未签名</span>
        </span>
        <el-popover placement="right-start" width="200" trigger="click" :content="orderDeatilsData.remark" popper-class="filterBar">
          <span slot="reference">{{ orderDeatilsData.remark || '  无' }}</span>
        </el-popover>
      </div>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
    isOpen: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      tooltipStatus: false, // 文字过长的显示和隐藏
      menusList: JSON.parse(sessionStorage.getItem('menusList')),
      IsAq: window.sessionStorage.IsAq || 1, // 安全设置-客户端签名开关
    };
  },
  activated() {
  },
  methods: {
  }
};
</script>
<style lang="less">
.filterBar {
  padding: 5px!important;
}
</style>

<style lang="less" scoped>

.autograph {
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  text-align: center;
  margin:10px 10px 0 0;
}
.autograph_D {
  border: 1px solid #e5e5e5;
  background-color: #f7f8fa;
  color: #999;
}
.autograph_G {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
</style>
